import { render, staticRenderFns } from "./TakenSurveyPage.vue?vue&type=template&id=49c953bc&"
import script from "./TakenSurveyPage.vue?vue&type=script&lang=ts&"
export * from "./TakenSurveyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports